<template>
	<button class="button" :class="'button--' + variant">
		<router-link :to="to" class="button-link">
			{{ text }}
			<span></span>
		</router-link>
	</button>
</template>

<script>
	export default {
		name: 'LinkButton',
		props: {
			to: {
				type: String,
				required: true
			},
			text: {
				type: String,
				required: true
			},
			// dark | dark-ghost | yellow | yellow-dark-border | yellow-noborder | yellow-translucent
			variant: {
				type: String,
				default: 'dark'
			}
		}
	}
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	/* ===== 公共骨架（8 个按钮共有部分） ===== */
	.button {
		border: none;
		display: block;
		position: relative;
		padding: 8px 30px;
		font-size: 20px;
		cursor: pointer;
		user-select: none;
		overflow: hidden;
	}

	.button-link {
		text-decoration: none;
	}

	.button span {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: transparent;
		z-index: -1;
	}

	.button span::before {
		content: "";
		position: absolute;
		width: 8%;
		height: 500%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(-60deg);
		transition: all 1s;
	}

	.button:hover span::before,
	.button:focus span::before {
		transform: translate(-50%, -50%) rotate(-90deg);
		width: 100%;
	}

	.button:hover,
	.button:focus {
		color: #000;
	}

	/* ===== dark（原 linebutton / linebutton4） ===== */
	.button--dark {
		background: rgb(35, 24, 21);
		color: #fff;
	}

	.button--dark span {
		border: 2pt solid #fff;
	}

	.button--dark span::before {
		background: rgb(35, 24, 21);
	}

	.button--dark:hover span::before,
	.button--dark:focus span::before {
		background: #fff000;
	}

	.button--dark .button-link {
		color: #fff;
	}

	/* ===== dark-ghost（原 linebutton2 / linebutton6） ===== */
	.button--dark-ghost {
		background: rgb(35, 24, 21);
		color: #fff;
	}

	.button--dark-ghost span {
		border: 2pt solid #fff;
	}

	.button--dark-ghost span::before {
		background: rgb(35, 24, 21, 0);
	}

	.button--dark-ghost:hover span::before,
	.button--dark-ghost:focus span::before {
		background: #fff;
	}

	.button--dark-ghost .button-link {
		color: #fff;
	}

	.button--dark-ghost:hover .button-link,
	.button--dark-ghost:focus .button-link {
		color: #000;
	}

	/* ===== yellow（原 linebutton1） ===== */
	.button--yellow {
		background: #fff100;
		color: #000;
	}

	.button--yellow span {
		border: 2pt solid #fff100;
	}

	.button--yellow span::before {
		background: #fff100;
	}

	.button--yellow:hover span::before,
	.button--yellow:focus span::before {
		background: #fff;
	}

	.button--yellow .button-link {
		color: #000;
	}

	/* ===== yellow-dark-border（原 linebutton3） ===== */
	.button--yellow-dark-border {
		background: #fff100;
		color: #000;
	}

	.button--yellow-dark-border span {
		border: 2pt solid rgb(35, 24, 21);
	}

	.button--yellow-dark-border span::before {
		background: #fff100;
	}

	.button--yellow-dark-border:hover span::before,
	.button--yellow-dark-border:focus span::before {
		background: #fff;
	}

	.button--yellow-dark-border .button-link {
		color: #000;
	}

	/* ===== yellow-noborder（原 linebutton5，span 无边框但有 padding） ===== */
	.button--yellow-noborder {
		background: #fff100;
		color: #000000;
	}

	.button--yellow-noborder span {
		padding: .5em 1.5em;
	}

	.button--yellow-noborder span::before {
		background: #fff100;
	}

	.button--yellow-noborder:hover span::before,
	.button--yellow-noborder:focus span::before {
		background: #fff;
	}

	.button--yellow-noborder .button-link {
		color: #000;
	}

	/* ===== yellow-translucent（原 linebutton7） ===== */
	.button--yellow-translucent {
		background: rgb(255, 244, 57, 0.3);
		color: #000000;
	}

	.button--yellow-translucent span {
		border: 2pt solid rgb(35, 24, 21);
	}

	.button--yellow-translucent span::before {
		background: rgb(255, 244, 57, 0.2);
	}

	.button--yellow-translucent:hover span::before,
	.button--yellow-translucent:focus span::before {
		background: #fff;
	}

	.button--yellow-translucent .button-link {
		color: #000;
	}
</style>
